import { Dispatch, ForwardedRef, InputHTMLAttributes, ReactElement, SetStateAction } from 'react';

export interface FormElementProps {
  klass?: string;
  customClass?: string | boolean;
  variant?: string;
  size?: string;
  stretch?: boolean;
  error?: boolean;
}

export interface TextfieldProps extends FormElementProps, Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  setValid?: Dispatch<SetStateAction<boolean>>;
  forwardedRef?: ForwardedRef<HTMLInputElement>;
};

export interface TextGroupProps {
  name?: string;
  size?: string;
  label: string;
  inline?: boolean;
  className?: string;
  textProps: TextfieldProps;
}

export interface AlertProps {
  size?: string;
  variant?: string;
  title?: string;
  klass?: string;
  persist?: boolean;
  children?: ReactElement | string;
}

export interface EditFieldProps {
  value?: string;
  onSubmit?: (value: string) => void;
  onAbort?: () => void;
  loading?: boolean;
}

export interface CheckboxProps extends FormElementProps, Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  label: string;
  id: string;
}

export * from './Button';
export * from './Textfield';
export * from './Textarea';
export * from './Checkbox';
export * from './Label';
export * from './TextGroup';
export * from './EditField';
export * from './Alert';

